import React from "react";
import { Select } from "ui/Form/Select";

type Option = {
  value: string;
  label: string;
};

type SelectProps = {
  options: Option[];
  placeholder?: string;
  value: string;
  name: string;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const SessionsSelect = ({
  options,
  placeholder = "Seleccione un container",
  value,
  name,
  disabled,
  onChange,
}: SelectProps) => {
  const enhancedOptions = [{ value: "", label: placeholder }, ...options];

  return (
    <Select
      name={name}
      label=""
      options={enhancedOptions}
      placeholder={placeholder}
      disabled={disabled}
      onChange={onChange}
      aria-label="Sessions Select"
      value={value}
    />
  );
};

export default SessionsSelect;
